import React from 'react';
import {
  ResponsiveContainer,
  ComposedChart,
  Scatter,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Line,
} from "recharts";

  console.log("WtBalGraph LOADED >>> NEW FILE 2026-02-26 A");

  // Define some static data points
  /*const ENVELOPE = [
    { cg: 42.0, weight: 1591, name: 'Point 1' },
    { cg: 42.0, weight: 2130, name: 'Point 2' },
    { cg: 46.21, weight: 2575, name: 'Point 3' },
    { cg: 47.0, weight: 2591, name: 'Point 4' },
    { cg: 47.0, weight: 1591, name: 'Point 5' }, 
    { cg: 42.0, weight: 1591, name: 'Point 6' }, 

  ]; */
    const toNum = (v) => {
      const n = Number(v);
      return Number.isFinite(n) ? n : null;
  };

  export default function WtBalGraph({ data = [], envelope = [] }) {
  console.log("WtBalGraph received data:", data);
  console.log("WtBalGraph received envelope:", envelope);

  // Accept either cgIn/cg and Weight/weight/wt from caller
  const aircraftPoints = (data || [])
    .map((p) => ({
      cg: toNum(p.cgIn ?? p.cg),
      weight: toNum(p.Weight ?? p.weight ?? p.wt),
    }))
    .filter((p) => p.cg != null && p.weight != null);

  const envPoints = (envelope || [])
    .map((p) => ({
      cg: toNum(p.cgIn ?? p.cg),
      weight: toNum(p.weightLbs ?? p.weight ?? p.Weight),
    }))
    .filter((p) => p.cg != null && p.weight != null);  


  console.log("WtBalGraph aircraftPoints:", aircraftPoints);
 /* references */
 /* https://www.react-graph-gallery.com/scatter-plot */
 
  return (
    <div style={{ width: "100%", height: 380 }}>
    <ResponsiveContainer>
      <ComposedChart margin={{ top: 20, right: 30, bottom: 20, left: 10 }}>
        <CartesianGrid />

        <XAxis 
        type="number" 
        dataKey="cg" 
        name="CG" 
        domain={[
          (dataMin) => dataMin - 2,
          (dataMax) => dataMax + 1 

        ]}
        />
        <YAxis type="number" dataKey="weight" name="weight" domain={["auto", "auto"]}/>
        <Tooltip formatter={(value, name) => [value, name]} labelFormatter={() => ""}/>

        <Line 
          data={envPoints}    // change from data = {ENVELOPE}
          type="linear" 
          dataKey="weight" 
          stroke="#000000"        // force black
          strokeWidth={3} 
          dot={false} 
          isAnimationActive={false} 
          />
        <Scatter 
          name="Aircraft CG" 
          data={aircraftPoints} 
          fill="#ff7300"
          isAnimationActive={false}
          shape={(props) => {
            const { cx, cy, payload } = props;
            if (!Number.isFinite(cx) || !Number.isFinite(cy)) return null;
            
            return (
            <g>
              <circle cx={cx} cy={cy} r={6} fill="#ff7300" />
              <text 
              x={cx + 10} 
              y={cy - 10} 
              fontSize={18}
              fontWeight="bold" 
              fill="#333"
              > {`CG=${payload.cg.toFixed(1)}`}
              </text>
            </g>
            );
          }}/>
      </ComposedChart>
    </ResponsiveContainer>
    </div>
  );
};
